import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Download, Smartphone, X } from "lucide-react";
import { usePWA } from "@/hooks/usePWA";
import { useState } from "react";

export function InstallPrompt() {
  const { isInstallable, installApp } = usePWA();
  const [dismissed, setDismissed] = useState(false);

  if (!isInstallable || dismissed) return null;

  return (
    <Card className="mb-6 border-primary/20 bg-gradient-to-r from-primary/5 to-accent/5">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <div className="flex items-center space-x-2">
          <Smartphone className="h-5 w-5 text-primary" />
          <CardTitle className="text-lg">App installieren</CardTitle>
        </div>
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => setDismissed(true)}
          className="h-8 w-8 p-0"
        >
          <X className="h-4 w-4" />
        </Button>
      </CardHeader>
      <CardContent>
        <CardDescription className="mb-4">
          Installiere Hearts Rewards auf deinem Gerät für einen schnelleren Zugriff und 
          Push-Benachrichtigungen über neue Prämien und Aktionen.
        </CardDescription>
        <Button onClick={installApp} className="w-full">
          <Download className="mr-2 h-4 w-4" />
          Jetzt installieren
        </Button>
      </CardContent>
    </Card>
  );
}